module.exports = __webpack_public_path__ + "media/src/assets/images/case-pic2-8a7dd7c4acf6d3bfd3532a2816fccaa3.png";